import { useRef } from 'react'

import useMediaQuery from '@equifax-ui/hooks/useMediaQuery'

export const useFilters = ({ activeFilterIndex, setActiveFilterIndex }) => {
  const filtersRef = useRef()
  const filtersItemsRefs = useRef([])

  const isMobile = useMediaQuery('screen and (max-width: 1024px)')

  const isOnScreen = (element) => {
    const { x } = element.getBoundingClientRect()

    return x > 0 && x < 80
  }

  const onScroll = () => {
    const nextVisibleFilter =
      filtersItemsRefs.current.findIndex((item) => isOnScreen(item)) ?? 0

    if (nextVisibleFilter >= 0 && nextVisibleFilter !== activeFilterIndex) {
      setActiveFilterIndex(nextVisibleFilter)
    }
  }

  const onSelectFilter = (index) => {
    const nextVisibleFilter = filtersRef.current.children[index]

    if (!nextVisibleFilter) return

    setActiveFilterIndex(index)
  }

  const onClickController = (direction) => {
    const { width } = filtersRef.current.getBoundingClientRect()
    const left = direction === 'left' ? -width : width

    requestAnimationFrame(() => {
      filtersRef.current.scrollBy({
        left,
        behavior: 'smooth'
      })
    })
  }

  return {
    filtersRef,
    filtersItemsRefs,
    isMobile,
    onScroll,
    onSelectFilter,
    onClickController
  }
}
